import moment from 'moment';

export const validStartDate = context => (startDate) => {
  const {
    validStartDates,
  } = context;
  const date = moment(startDate);
  const formatted = date.format('YYYY-MM-DD');
  if (validStartDates) {
    return validStartDates.indexOf(formatted) !== -1;
  }
  return false;
};

export const validEndDate = context => (endDate) => {
  const {
    // startDate,
    validEndDates,
  } = context;
  /* if (!startDate) {
    return false;
  } */
  const date = moment(endDate);
  const formatted = date.format('YYYY-MM-DD');
  if (validEndDates) {
    return validEndDates.indexOf(formatted) !== -1;
  }
  return false;
  /* const endMoment = moment(endDate);
  if (endMoment.day() !== 4 && endMoment.day() !== 0) {
    return false;
  }
  const range = moment.range(startDate, endDate);
  const diff = range.diff('days');
  return (diff > 1 && diff <= 7); */
};

export const validRangeDate = context => (value) => {
  const {
    // startDate,
    startDate,
    days,
    validStartDates,
  } = context;
  /* if (!startDate) {
    return false;
  } */
  const rangeStart = moment(startDate).subtract(1, 'days');
  const rangeEnd = moment(startDate).add(days, 'days');
  const date = moment(value);

  const validFromStartDate = validStartDates.indexOf(date.format('YYYY-MM-DD')) > -1;

  if (date.isAfter(rangeStart) && date.isBefore(rangeEnd) && validFromStartDate) {
    return true;
  }
  return false;
  /* const endMoment = moment(endDate);
  if (endMoment.day() !== 4 && endMoment.day() !== 0) {
    return false;
  }
  const range = moment.range(startDate, endDate);
  const diff = range.diff('days');
  return (diff > 1 && diff <= 7); */
};



// WEBPACK FOOTER //
// ./src/dates.js